import { render, staticRenderFns } from "./TraceabilityExamInclusion.vue?vue&type=template&id=001ba5bc"
import script from "./TraceabilityExamInclusion.vue?vue&type=script&lang=js"
export * from "./TraceabilityExamInclusion.vue?vue&type=script&lang=js"
import style0 from "./TraceabilityExamInclusion.vue?vue&type=style&index=0&id=001ba5bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports